<template>
  <div
    v-if="publicTranscriptUrl"
    class="bg-white rounded-lg shadow p-4 flex flex-col gap-2"
    data-testid="public-transcript-link"
  >
    <div class="flex items-center gap-2">
      <i class="pi pi-link text-primary"></i>
      <label class="font-semibold text-gray-700">Public transcript link</label>
    </div>
    <InputGroup>
      <InputText :value="publicTranscriptUrl" readonly data-testid="public-transcript-link-url" />
      <InputGroupAddon>
        <Button
          size="small"
          icon="pi pi-copy"
          text
          aria-label="Copy public transcript link"
          data-testid="public-transcript-link-copy"
          @click="copyLink"
        />
      </InputGroupAddon>
      <InputGroupAddon>
        <Button
          size="small"
          icon="pi pi-external-link"
          text
          aria-label="Open public transcript link"
          data-testid="public-transcript-link-open"
          @click="openLink"
        />
      </InputGroupAddon>
    </InputGroup>
    <small class="text-gray-500">
      Share this link so students can apply for a transcript from your school.
    </small>
  </div>
</template>

<script setup lang="ts">
import { useToast } from 'vue-toastification';
import { usePublicTranscriptLink } from '@/composables/transcript/usePublicTranscriptLink';

const toast = useToast();
const { publicTranscriptUrl } = usePublicTranscriptLink();

const copyLink = async() => {
  if (!publicTranscriptUrl.value) return;
  try {
    await navigator.clipboard.writeText(publicTranscriptUrl.value);
    toast.success('Public transcript link copied');
  } catch {
    toast.error('Could not copy the link. Please copy it manually.');
  }
};

const openLink = () => {
  if (!publicTranscriptUrl.value) return;
  window.open(publicTranscriptUrl.value, '_blank', 'noopener');
};
</script>
